import {Component, Input, OnInit} from '@angular/core';
import {RouterLink} from "@angular/router";
import {SubscribeComponent} from "../subscribe/subscribe.component";

@Component({
    selector: 'app-faq',
    standalone: true,
    templateUrl: './faq.component.html',
    imports: [
        RouterLink,
        SubscribeComponent
    ],
    styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {

    @Input() isOnHome: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
